export default function() {}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-shape/src/noop.js
// module id = ../../../../d3-shape/src/noop.js
// module chunks = 3